__webpack_require__.amdD = function () { throw new Error('define cannot be used indirect'); }